// Import main SCSS file
import './assets/sass/theme.scss';

// Import CSS from node_modules
require('@fancyapps/fancybox/dist/jquery.fancybox.css');
require('owl.carousel/dist/assets/owl.carousel.css');

// Import JavaScript
require('./assets/js/theme.js');
